import { Container, Stack, Text } from '@mantine/core'

import styles from './Placeholder.module.css'

const Placeholder = ({ t }: { t: string }) => (
  <Container px={30} className={styles.container}>
    <Stack align="center" justify="center" className={styles.stack}>
      <Text ta="center" c="dimmed">
        {t}
      </Text>
    </Stack>
  </Container>
)

export const FavoritesPlaceholder = () => (
  <Placeholder t="You have not favorited any documents yet." />
)

export const RecentPlaceholder = () => (
  <Placeholder t="No documents have been edited in the last 30 days." />
)

export const MyHistoryPlaceholder = () => (
  <Placeholder t="You have not opened any documents yet." />
)
